import { Component, OnInit, Input, Output, ContentChildren, ElementRef, EventEmitter, QueryList } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CfCoreComponent } from '../core/core.component';
import { CfFormComponent } from '../form/form.component';
import { ButtonModel } from '../../models/button/button.model';
import { FormGroupModel } from '../../models/form/form-group.model';
import { FormGroupStylingModel } from '../../models/form/form-group-styling.model';
import { FormGroupTemplates } from '../../templates/form-group.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Form Group Component</p>
 * <pre>
 * <code>
 * import {{'{'}} FormGroupModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} FormGroupStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-form-group<code>></code><code><</code><code>/</code>cf-form-group<code>></code>
 * </code>
 * </pre>
 */
export class CfFormGroupComponent extends CfCoreComponent implements OnInit {
/**
 * <p>Example:</p>
 * <code><pre>{{'{'}}
 *  title: 'Person body',
 *  payload: this.personBody,
 *  submitButton: {{'{'}} label: 'Save' {{'}'}}
 * {{'}'}}</pre></code>
 * <h4>title: string</h4>
 * Form group title
 * <h4>payload: any</h4>
 * Incoming data for the group forms
 * <h4>submitButton: ButtonModel</h4>
 * Group submit button
 */
properties: FormGroupModel;
/**
 * <p>Styling object:</p>
 * <h4>container: StylingModel</h4>
 * Styling properties for main container
 * <h4>title: StylingModel</h4>
 * Styling for the title
 * <h4>content: StylingModel</h4>
 * Styling for the content
 * <h4>submitSection: StylingModel</h4>
 * Styling for the submit section
 * <h4>submitButton: ButtonStylingModel</h4>
 * Styling for submit button
 */
styling: FormGroupStylingModel;
/**
 * Group title
 * @param {?} value
 * @return {?}
 */
set title(value: string) { this.properties.title = value; }
/**
 * Incoming data for the group forms
 * @param {?} value
 * @return {?}
 */
set payload(value: any) { this.properties.payload = value; }
/**
 * Group submit button
 * @param {?} value
 * @return {?}
 */
set submitButton(value: ButtonModel) { this.properties.submitButton = value; }
/**
 * @hidden
 */
cfForms: QueryList<CfFormComponent>;
/**
 * @hidden
 */
group: any = {};
/**
 * @hidden
 */
form: FormGroup;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new FormGroupModel();
    this.styling = new FormGroupStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    super.ngOnInit();
    this.getMyTemplate('form-group', FormGroupTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'FORM-GROUP').then(sampler => {
        this.styling = Object.assign({}, this.activeTemplate.style, this.styling);
        // console.log('FORM-GROUP', this);
      });
    });
  }
/**
 * @hidden
 * @return {?}
 */
ngAfterContentInit() {
    if (this.cfForms != null && this.cfForms.length > 0) {
      this.cfForms.toArray().forEach((cfForm, index) => {
        cfForm.properties.submitButton.display = false;
        if (cfForm.properties.key === '') { cfForm.properties.key = 'form' + index; }
        this.group[cfForm.properties.key] = cfForm.form;
      });
      this.form = new FormGroup(this.group);
    }
  }
/**
 * @hidden
 * @return {?}
 */
onSubmit() {
    this.payload = JSON.stringify(this.form.value);
    return this.payload;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-form-group',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"cf-form-group-container {{styling?.container?.class}}\" [ngClass]=\"getDynamicClasses(styling?.container?.dynamicClass)\"> <h5 *ngIf=\"properties?.title!=null\" class=\"cf-form-group-title {{styling?.title?.class}}\" [ngClass]=\"getDynamicClasses(styling?.title?.dynamicClass)\">{{properties?.title}}</h5> <div class=\"cf-form-group-content {{styling?.content?.class}}\" [ngClass]=\"getDynamicClasses(styling?.content?.dynamicClass)\"><ng-content></ng-content></div> <div class=\"cf-form-group-submit-section {{styling?.submitSection?.class}}\" [ngClass]=\"getDynamicClasses(styling?.submitSection?.dynamicClass)\"> <cf-button (onClick)=\"onSubmit()\" [disable]=\"!form.valid\" [properties]=\"properties.submitButton\" [styling]=\"styling?.submitButton\"></cf-button> </div> </div>",
  styles: [".cf-form-group-submit-section { display: flex; justify-content: flex-end; margin-top: 10px; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'title': [{ type: Input, args: ['title', ] },],
'payload': [{ type: Input, args: ['payload', ] },],
'submitButton': [{ type: Input, args: ['submitButton', ] },],
'cfForms': [{ type: ContentChildren, args: [CfFormComponent, ] },],
};
}

function CfFormGroupComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfFormGroupComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfFormGroupComponent.ctorParameters;
/** @type {?} */
CfFormGroupComponent.propDecorators;
/**
 * <p>Example:</p>
 * <code><pre>{{'{'}}
 *  title: 'Person body',
 *  payload: this.personBody,
 *  submitButton: {{'{'}} label: 'Save' {{'}'}}
 * {{'}'}}</pre></code>
 * <h4>title: string</h4>
 * Form group title
 * <h4>payload: any</h4>
 * Incoming data for the group forms
 * <h4>submitButton: ButtonModel</h4>
 * Group submit button
 * @type {?}
 */
CfFormGroupComponent.prototype.properties;
/**
 * <p>Styling object:</p>
 * <h4>container: StylingModel</h4>
 * Styling properties for main container
 * <h4>title: StylingModel</h4>
 * Styling for the title
 * <h4>content: StylingModel</h4>
 * Styling for the content
 * <h4>submitSection: StylingModel</h4>
 * Styling for the submit section
 * <h4>submitButton: ButtonStylingModel</h4>
 * Styling for submit button
 * @type {?}
 */
CfFormGroupComponent.prototype.styling;
/**
 * @hidden
 * @type {?}
 */
CfFormGroupComponent.prototype.cfForms;
/**
 * @hidden
 * @type {?}
 */
CfFormGroupComponent.prototype.group;
/**
 * @hidden
 * @type {?}
 */
CfFormGroupComponent.prototype.form;
/**
 * @hidden
 * @type {?}
 */
CfFormGroupComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
